export default __webpack_public_path__ + "static/media/Bilal.724a4c71.jpg";